import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

window.addEventListener('load', function () {

    const homeSlider = new Swiper('#makeBusinessContent-slider .swiper', {
        modules: [Autoplay, Navigation, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 6000,
        },
        navigation: {
            nextEl: '#makeBusinessContent-slider .swiper-button-next',
            prevEl: '#makeBusinessContent-slider .swiper-button-prev',
        },
        pagination: {
            el: '#makeBusinessContent-slider .swiper-pagination',
            clickable: true,
        },
    });
})

document.getElementById('makeBusinessHeader-button').addEventListener('click', () => {
    document.getElementById('makeBusinessContent').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
})

document.getElementById('makeBusinessContent-form--toggle').addEventListener('click', () => {
    document.getElementById('makeBusinessContent-form').scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
})

// Ajouter une ancre au chargement de la page
window.onload = function() {
    let formMessage = document.getElementById('makeBusinessContent-form');
    let confirmation = formMessage.dataset.confirmation;

    if(confirmation) {
        formMessage.scrollIntoView({ behavior: 'smooth' });
    }
};
